import { useQuery } from 'react-query';
import { useService } from 'shared/providers';

export function useCustomerProductNumbers(customerId: string, productId: string) {
  const { quoteService } = useService();
  const { data, isLoading, isFetching } = useQuery<string[], Error>(
    [`customer-product-number|${productId}`],
    () => quoteService.getCustomerProductNumbers(customerId, productId),
    {
      enabled: Boolean(customerId && productId),
      retry: false,
    }
  );
  return { options: data, isLoading, isFetching } as const;
}
